export const getHoursFromTotalHoursPercentage = (hours: number, totalHours: number): number => {
	if (!totalHours || !hours) {
		return 0;
	}

	return (hours / totalHours) * 100;
};
